import { render } from "./MetacakeChart.vue?vue&type=template&id=748cba1b&scoped=true"
import script from "./MetacakeChart.vue?vue&type=script&lang=ts"
export * from "./MetacakeChart.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-748cba1b"

export default script